import { useEffect, useRef } from 'react';

import { UniversalMenuItem } from '@klv/molecules/universal-menu-item';
import { generateClassName } from '@klv/shared/utils/functions';
import { gtmBasicEvent } from '@klv/shared/utils/google-tag-manager';
import { Accordion } from '@klv/utils/accordion';

import * as styles from './styles/universalFooterMenu.module.scss';

import type { IUniversalMenuItemWithCustomFields } from '@klv/shared/types';
import type { TBackgroundColor } from '../../types';

const handleClick = ({ childItem, menuItem }: { childItem: string; menuItem: string; }) => {
  gtmBasicEvent({
    action: menuItem,
    category: 'footer_nav',
    label: childItem,
  });
};

export const Menu = ({
  menuItem,
  backgroundColor,
  open = false,
}: {
  menuItem: IUniversalMenuItemWithCustomFields;
  backgroundColor: TBackgroundColor;
  open?: boolean;
}) => {
  const ref = useRef<HTMLDetailsElement>(null);

  useEffect(() => {
    if (ref.current) {
      new Accordion(ref.current);
    }
  }, [ref]);

  useEffect(() => {
    const handleResize = () => {
      if (ref.current) {
        ref.current.open = window.matchMedia('(min-width: 1024px)').matches;
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
  }, []);

  return (
    <details className={styles.dropdown} ref={ref} open={open}>
      <summary className={styles.menuTitle}>
        <span className={styles.label}>{menuItem.label}</span>
      </summary>
      <ul className={generateClassName(['content', styles.menuList])}>
        {menuItem?.childItems?.map(({ id, label, url, ...rest }) => (
          <li key={id} className={styles.menuListItem}>
            <UniversalMenuItem
              backgroundColor={backgroundColor}
              href={url}
              label={label}
              onClick={() => handleClick({ childItem: label, menuItem: menuItem.label })}
              {...rest}
            />
          </li>
        ))}
      </ul>
    </details>
  );
};
